import { ESessionFeatures } from '@/types/session-features.types';
import { THandleUpdateFeatureProps } from './update-methods.types';
import { saveWorkingProjectSessionByField } from '@/store/slices/project';

const handleUpdateFeaturesBySession = async ({ session, toggledFeature, dispatch }: THandleUpdateFeatureProps) => {
  switch (toggledFeature) {
    case ESessionFeatures.CHAT: {
      const isOn = session.session_chat_enabled;
      dispatch(
        saveWorkingProjectSessionByField({
          uuid: session.uuid,
          session_chat_enabled: !isOn,
        })
      );
      break;
    }
    case ESessionFeatures.CAPTIONS: {
      const isOn = !!session.streaming_options?.auto_transcripts;
      dispatch(
        saveWorkingProjectSessionByField({
          uuid: session.uuid,
          streaming_options: {
            ...session.streaming_options,
            auto_transcripts: !isOn,
          },
        })
      );
      break;
    }
    case ESessionFeatures.COURSES: {
      const isOn = !!session.courses_settings?.enabled;
      dispatch(
        saveWorkingProjectSessionByField({
          uuid: session.uuid,
          courses_settings: {
            ...(session.courses_settings || {}),
            enabled: !isOn,
          },
        })
      );
      break;
    }
  }
};

export default handleUpdateFeaturesBySession;
